<ng-template #contentRating let-modal class="modal-share p-3">
  <div class="modal-header container border-0 pt-3">

    <button type="button" class="btn-close btn-close-black me-1" aria-label="Close"
            (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body p-0">

    <div class="p-3 text-center">
      <h4>Compte-rendu de visite
      </h4>
    </div>

    <div class="bar-bloc text-white">
      <div class="product-desc agenda-page main-bg p-3">
        <div class="title-description white-title">
          <div class="inner">
            <div class="title-description text-uppercase">

              <h3 class="white">{{bien.niveau.code_text}} <span *ngIf="bien.property.size_generique">de
                {{bien.property.size_generique}} m²</span> à<br>
                <span class="accent">{{bien.ville}}</span>
              </h3>
            </div>
            <p class="clearfix big-title">
              <span style="float:right" class="float-right price-title">
                {{bien?.property.price_formatted}}&nbsp;€
              </span>
            </p>

            <p class="location-title italic-title"
               *ngIf="bien?.property?.adresseBien && !bien?.property.adresseBien.codePostalF">
              {{bien?.property.location ? bien?.property.location : bien?.location}
            </p>

            <div class="details clearfix">
              <span class="badge-list-item outlined">
                  Ref : {{bien.property.reference}}
              </span>
              <svg width="48" height="48" viewBox="0 0 15 15" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path d="M5.40446 3.85168H3.08008V6.17606" stroke="#ffffff" stroke-width="0.8"
                      stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9.18199 11.9871H11.2158V9.95323" stroke="#ffffff" stroke-width="0.8"
                      stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5.11391 11.9871H3.08008V9.95323" stroke="#ffffff" stroke-width="0.8"
                      stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5.98555 9.37213L3.08008 11.9871" stroke="#ffffff" stroke-width="0.8"
                      stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9.18199 3.85168H11.2158V5.88552" stroke="#ffffff" stroke-width="0.8"
                      stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8.31035 6.46661L11.2158 3.85169" stroke="#ffffff" stroke-width="0.8"
                      stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span> {{bien.property.size_generique}} m²</span>

              <span *ngIf="bien.property.pieces">
                <svg width="48" height="48" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.01309 6.46665V4.14227H1.20215V12.2776H12.2429V4.14227H9.62802"
                        stroke="#ffffff" stroke-width="0.8" stroke-linecap="round"
                        stroke-linejoin="round"/>
                  <path d="M4.68848 12.2776L4.68848 7.91937" stroke="#ffffff" stroke-width="0.8"
                        stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12.2429 8.2099H8.46582" stroke="#ffffff" stroke-width="0.8"
                        stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                {{bien?.property.pieces ? bien?.property.pieces : bien?.pieces}} Pièce(s)
              </span>
              <span *ngIf="(bien?.property.room ? bien?.property.room : bien?.room)">
                <svg width="48" height="48" viewBox="0 0 25 25" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M19.1635 18.388L17.8085 16.2649H4.63487L3.40301 18.3373C3.29432 18.5185 3.01172 18.446 3.01172 18.2286V10.9679C3.01172 10.7651 3.17838 10.5984 3.38127 10.5984H19.178C19.3809 10.5984 19.5475 10.7651 19.5475 10.9679V18.2793C19.5475 18.4895 19.2722 18.5692 19.1635 18.3953V18.388Z"
                    stroke="#ffffff" stroke-width="0.8" stroke-miterlimit="10"/>
                  <path
                    d="M3.91016 10.5984V5.46811L4.06957 5.42463C8.80134 4.24351 13.7505 4.25075 18.475 5.44637L18.562 5.46811V10.5984"
                    stroke="#ffffff" stroke-width="0.8" stroke-miterlimit="10"/>
                  <path
                    d="M12.5186 10.5984V9.69263C12.5186 8.48976 13.4968 8.10571 14.6997 8.10571C15.9025 8.10571 16.8808 8.48976 16.8808 9.69263V10.5984"
                    stroke="#ffffff" stroke-width="0.8" stroke-miterlimit="10"/>
                  <path
                    d="M5.52539 10.5984V9.69263C5.52539 8.48976 6.49638 8.10571 7.69925 8.10571C8.90212 8.10571 9.88035 8.48976 9.88035 9.69263V10.5984"
                    stroke="#ffffff" stroke-width="0.8" stroke-miterlimit="10"/>
                </svg>
                {{bien?.property.room ? bien?.property.room : bien?.room}}
                Chambre{{(bien?.property.room ? bien?.property.room : bien?.room) > 1 ? 's' : ''}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- version écriture -->
    <div *ngIf="!readOnly" class="data-bloc-rating p-4">
      <div class="fw-semibold text-center">
        Merci de répondre aux questions affichées et ajouter un commentaire
      </div>
      <div *ngIf="!showAlert" class="row">
        <div class="outer-bloc-characteristics">
          <div class="characteristics" *ngIf="evaluations_questions.length > 0">
            <p class="right fw-semibold"><span class="label-rating">Note de 0 à 5</span></p>
          </div>
          <div class="characteristics">
            <form action="">
              <p class="inner-rating clearfix" *ngFor="let qcm of evaluations_questions">
                <span class="left label-rating">{{qcm.question}}</span>
                <span class="right pad-rating mx-2">
                    <ng-template #t let-fill="fill">
                        <i class="bi-heart-fill">
                            <i *ngIf="fill > 0" class="bi-heart-fill filled" [style.width.%]="fill"></i>
                        </i>
                    </ng-template>

                    <ngb-rating [(rate)]="qcm.response" [starTemplate]="t" [readonly]="false" [max]="5"
                                [ariaValueText]="ariaValueText"></ngb-rating>
                </span>
              </p>
              <fieldset class="textarea-wrapper">
                <div class="inner-form clear">
                  <p class="input-wrapper">
                    <textarea name="comment" #comment class="form-control" id="comment"
                              aria-label="Saisir votre commentaire"
                              placeholder="Saisir votre commentaire" cols="30" rows="10"></textarea>
                  </p>
                  <p *ngIf="typeOfEvaluation == 'compte-rendu'">Le vendeur prendra connaissance
                    de votre compte-rendu</p>
                </div>
              </fieldset>
              <p class="text-center bottom-form">
                <button class="btn btn-primary big-txt"
                        (click)="onSaveQuestion(comment.value)">Envoyer le compte-rendu
                </button>
              </p>
            </form>
          </div>
        </div>
      </div>
      <div *ngIf="showAlert" class="text-center mb-5">
        <img class="my-3" src="../../../../../assets/resources/web/images/design/ok.png">
        <h4 class="fw-bolder">{{messageConfirmation}}</h4>
        <div class="my-3" role="button" (click)="modal.dismiss('Cross click')">
          <button class="btn btn-outline-primary">
            Retour<i style="color: #00579C;" class="bi bi-arrow-right mx-2  h4"></i></button>
        </div>
      </div>
    </div>
    <!-- version lecture -->
    <div *ngIf="readOnly" class="data-bloc-rating p-4">
      <div *ngIf="!showAlert" class="row">
        <div class="outer-bloc-characteristics">
          <div class="characteristics">
            <form action="" *ngIf="visite?.visit_detail">
              <br>
              <p class="inner-rating clearfix"
                 *ngFor="let qcm of visite?.visit_detail?.keysitter?.report?.status">
                <span class="left label-rating">{{qcm.label}}</span>
                <span class="right pad-rating mx-2">
                    <ng-template #t let-fill="fill">
                        <i class="bi-heart-fill">
                            <i *ngIf="fill > 0" class="bi-heart-fill filled" [style.width.%]="fill"></i>
                        </i>
                    </ng-template>

                    <ngb-rating [(rate)]="qcm.value" [starTemplate]="t" [readonly]="true" [max]="5"
                                [ariaValueText]="ariaValueText"></ngb-rating>
                </span>
              </p>
              <fieldset *ngIf="visite?.visit_detail?.keysitter?.report?.validated_comment || bien.proprietaire.id != userConnected.id" class="textarea-wrapper">
                <div class="inner-form clear">
                  <p class="text-bleu-tdm fw-semibold">
                    <br>{{visite?.visit_detail?.keysitter?.report?.comment}}
                  </p>
                </div>
              </fieldset>
            </form>
            <form action="" *ngIf="visite?.report">
              <br>
              <p class="inner-rating clearfix"
                 *ngFor="let qcm of visite?.report?.responses">
                <span class="left label-rating">{{qcm.rubric.question}}</span>
                <span class="right pad-rating mx-2">
                    <ng-template #t let-fill="fill">
                        <i class="bi-heart-fill">
                            <i *ngIf="fill > 0" class="bi-heart-fill filled" [style.width.%]="fill"></i>
                        </i>
                    </ng-template>

                    <ngb-rating [(rate)]="qcm.score" [starTemplate]="t" [readonly]="true" [max]="5"
                                [ariaValueText]="ariaValueText"></ngb-rating>
                </span>
              </p>
              <fieldset *ngIf="visite?.report?.validated_comment || bien.proprietaire.id != userConnected.id" class="textarea-wrapper">
                <div class="inner-form clear">
                  <p class="text-bleu-tdm fw-semibold">
                    <br>{{visite?.report?.comment}}
                  </p>
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<a role="button" *ngIf="!readOnly && !hiddeButton" class="w-100 text-white p-2 mt-2 fw-semibold"
   (click)="openVertically(contentRating)">
  <i class="bi bi-chat-square-dots-fill mx-2"></i>Rédiger votre compte-rendu
</a>

<a role="button" *ngIf="readOnly && !hiddeButton" class="w-100 text-white p-2 mt-2 fw-semibold"
   (click)="openVertically(contentRating)">
  <i class="bi bi-chat-square-dots-fill mx-2"></i>Consulter le compte-rendu
</a>
